import { MutationTree, StoreOptions, Module, GetterTree } from 'vuex';
import { VuexState } from '@/interfaces/vuexStateInterface';
import VuexModuleState from '@/interfaces/vuexModuleStateInterface';

const mutations: MutationTree<VuexModuleState> = {
  setAnswerTye(state, data) {
    state.answerTye = data;
  }
};
const getters: GetterTree<VuexModuleState, VuexState> = {
  getAnswerTye(state) {
    return state.answerTye;
  }
};

const activityStore: Module<VuexModuleState, VuexState> = {
  namespaced: true,
  state: {
    answerTye: 3 // 1 新增 2 编辑  3 发布
  },
  getters,
  mutations
};

export default activityStore;
